import React, { useEffect } from "react";
import { Modal, Table } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import { AppConfigActions, selectClientRiskCraScreen, selectCraRisksLoading } from "@redux";
import { i18, trb, writeExcelFile } from "@utilities";
import { ContentLoader } from "@components";

import "./AllRisksCraScreen.less";

const COL_WIDTHD = [
  { wch: 10 },
  { wch: 15 },
  { wch: 15 },
  { wch: 30 },
  { wch: 20 },
  { wch: 20 },
  { wch: 50 },
  { wch: 10 },
  { wch: 35 }
];

export const AllRisksCraScreen = ({ onClose }) => {
  const dispatch = useDispatch();
  const craScreenRisks = useSelector(selectClientRiskCraScreen);
  const isLoading = useSelector(selectCraRisksLoading);

  useEffect(() => {
    if (craScreenRisks.length !== 0) return;
    (async () => {
      await dispatch(AppConfigActions.getAllClientRisksScreen());
    })();
  }, [craScreenRisks]);

  const onPrint = () => {
    writeExcelFile({
      items: craScreenRisks,
      fileName: "cra screen risks",
      colWidths: COL_WIDTHD
    });
  };

  const columns = [
    {
      title: trb(i18.ApplicationsLabels.CraScreenClientName),
      dataIndex: "clientName",
      key: "clientName"
    },
    {
      title: trb(i18.ApplicationsLabels.CraScreenClientCode),
      dataIndex: "clientCode",
      key: "clientCode"
    },
    {
      title: trb(i18.ApplicationsLabels.CraScreenAppId),
      dataIndex: "applicationId",
      key: "applicationId"
    },
    {
      title: trb(i18.ApplicationsLabels.CraScreenDescription),
      dataIndex: "riskRDescription",
      key: "riskRDescription",
      width: "35%"
    },
    {
      title: trb(i18.ApplicationsLabels.CraScreenRiskType),
      dataIndex: "riskType",
      key: "riskType"
    },
    {
      title: trb(i18.ApplicationsLabels.CraScreenFinalRisk),
      dataIndex: "finalRisk",
      key: "finalRisk"
    },
    {
      title: trb(i18.ApplicationsLabels.CraScreenFinalRiskActual),
      dataIndex: "finalRiskActual",
      key: "finalRiskActual"
    },
    {
      title: trb(i18.ApplicationsLabels.CraScreenRiskScore),
      dataIndex: "riskScore",
      key: "riskScore"
    },
    {
      title: trb(i18.ApplicationsLabels.CraScreenRiskScoreTotal),
      dataIndex: "totalScore",
      key: "totalScore"
    }
  ];

  return (
    <Modal
      visible
      width="90%"
      className="risks-cra-screen-modal"
      onOk={onPrint}
      onCancel={onClose}
      cancelText={trb(i18.Buttons.Cancel)}
      okText={trb(i18.Buttons.GetExcelRisksScreen)}
      okButtonProps={{ loading: isLoading, icon: <FileExcelOutlined className="btn-icon" /> }}
    >
      {isLoading && <ContentLoader />}
      {!isLoading && (
        <Table
          className="w-100 my-4"
          dataSource={craScreenRisks}
          columns={columns}
          scroll={{ x: "60vw" }}
          pagination={false}
          size="small"
        />
      )}
    </Modal>
  );
};
